import React from 'react';
import { Box, Container, Flex } from '@qga/roo-ui/components';
import useDestination from '@/hooks/useDestination';
import Heading from '@/components/Heading';
import { DestinationCard } from '@/v2/components/ui/DestinationCard';

import { useDestination as v2UseDestination } from '@/v2/contexts/destination';

const RelatedDestinations = React.memo(() => {
  const d = useDestination();
  const dV2 = v2UseDestination();

  const destination = d || dV2;
  const { relatedDestinations } = destination;

  return (
    <Box pt={['6', null, '9']} mb="8">
      <Container>
        <Box mb="4" ml={[null, null, '2']}>
          <Heading.h3>Popular holiday destinations</Heading.h3>
        </Box>
        <Flex flexWrap="wrap" justifyContent="space-around">
          {relatedDestinations.map(
            ({ name, title, image, properties }, index) => (
              <Box
                key={name}
                width={['100%', null, 'calc(100%/4 - 16px)']}
                my="2"
              >
                <DestinationCard
                  name={name}
                  title={title}
                  image={image}
                  properties={properties}
                  index={index}
                />
              </Box>
            ),
          )}
        </Flex>
      </Container>
    </Box>
  );
});

export default RelatedDestinations;
